import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';

export interface DialogData {
  title: string,
  details: string,
  parking: string,
  waterSupply: string,
  electricity: string,
  telecommunication: string,
  gasSupply: string,
  otherFacilities: string
}

@Component({
  selector: 'app-edit-property-facilities',
  templateUrl: './edit-property-facilities.component.html',
  styleUrls: ['./edit-property-facilities.component.css']
})
export class EditPropertyFacilitiesComponent{


  @ViewChild('mapContainer', {static: false}) gmap: ElementRef

  @ViewChild('location', {static: false}) location: ElementRef

  remainingLength: number

  otherFacilities: FormArray

  otherFacility: FormGroup

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: false,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Describe your property here.',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['fontSize']
    ]
  };

  basicInfoForm: FormGroup = new FormGroup({
    title: new FormControl('', [Validators.required]),
    details: new FormControl(''),
    parking: new FormControl(''),
    waterSupply: new FormControl(''),
    electricity: new FormControl(''),
    telecommunication: new FormControl(''),
    gasSupply: new FormControl(''),
    otherFacilities: new FormControl('')
  })

  constructor(public dialogRef: MatDialogRef<EditPropertyFacilitiesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private formBuilder: FormBuilder) {
    this.basicInfoForm.setValue(data)
    this.otherFacility = new FormGroup({
      forms: this.formBuilder.array([])
    })
    if(data.otherFacilities){
      let otherFacilities = JSON.parse(data.otherFacilities)
      for(let otherFacility of otherFacilities){
        this.createFormArray(otherFacility)
      }
    }else{
      this.createFormArray({title: '', details: ''})
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  savePropertyBasicInfo(){
    let forms = this.otherFacility.get('forms')['controls']
    let facilities = []
    if(forms.length > 0){
      for(let form of forms){
        if(form.valid){
          let facilityInfo = form.value
          facilities.push(facilityInfo)
        }
      }
    }
    this.basicInfoForm['controls']['otherFacilities'].setValue(JSON.stringify(Array.from(facilities)))
    if(this.basicInfoForm.valid){
      let basicInfo = this.basicInfoForm.value

      this.dialogRef.close(basicInfo)
    }
  }

  createFormArray(otherFacility){
    this.otherFacilities = this.otherFacility.get('forms') as FormArray
    this.otherFacilities.push(this.createGroup(otherFacility))
  }

  createGroup(otherFacility): FormGroup {
    let otherFacilityForm =  this.formBuilder.group({
      title: new FormControl('', [Validators.required]),
      details: new FormControl('', [Validators.required])
    })
    otherFacilityForm.setValue(otherFacility)
    return otherFacilityForm
  }

  addOtherFacility(){
    this.createFormArray({title: '', details: ''})
  }

  removeOtherFacilityAt(index){
    this.otherFacilities.removeAt(index)
  }

}
